import { render, staticRenderFns } from "./cms-page.vue?vue&type=template&id=b3555ee4&scoped=true&"
import script from "./cms-page.vue?vue&type=script&lang=ts&"
export * from "./cms-page.vue?vue&type=script&lang=ts&"
import style0 from "./cms-page.vue?vue&type=style&index=0&id=b3555ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3555ee4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsBreadcrumbs: require('/var/www/packages/theme/components/atoms/Breadcrumbs.vue').default,AtomsAdSlot: require('/var/www/packages/theme/components/atoms/AdSlot.vue').default,MoleculesUsps: require('/var/www/packages/theme/components/molecules/Usps.vue').default})
